import { CloseOutlined } from '@ant-design/icons';
import { css } from '@styled-system/css';
import type { FC, ReactNode } from 'react';

interface FilterTagProps {
  name: string;
  value: ReactNode;
  onRemove: () => void;
}

export const FilterTag: FC<FilterTagProps> = ({ name, value, onRemove }) => {
  return (
    <div
      className={css({
        bg: 'border.default',
        display: 'flex',
        gap: 'xxs',
        alignItems: 'center',
        px: '2',
        py: '0.5',
        borderRadius: '4px',
        fontSize: '11px',
        fontFamily: 'Manrope, sans-serif',
        color: 'text.primary',
      })}
    >
      <span>{name}</span>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4 6H8M8 6L6.5 4.5M8 6L6.5 7.5"
          stroke="currentColor"
          strokeWidth="1"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span>{value}</span>
      <button
        type="button"
        onClick={onRemove}
        className={css({
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          border: 'none',
          bg: 'transparent',
          p: 0,
        })}
      >
        <CloseOutlined className={css({ fontSize: '12px', color: 'text.primary' })} />
      </button>
    </div>
  );
};
